import UpdatePassword from 'src/features/auth/components/templates/update-password';

export const UpdatePasswordContainer = () => {
  return <UpdatePassword />;
};
